import React from 'react';
import { motion } from 'framer-motion';
import { Check, Star, StarHalf } from 'lucide-react';
import { useGclid } from '../hooks/useGclid';
import { buildShopUrl, trackCTAClick } from '../utils/tracking';
const SHOP_URL = 'https://hunderunde.shop/products/futtertopping-magen-darm';
export function CTASection() {
  const gclid = useGclid();
  const href = buildShopUrl(SHOP_URL, gclid);
  return <section className="w-full py-20 px-4 bg-cream" data-id="element-43">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto text-center" data-id="element-44">
        <h2 className="font-handwriting text-5xl md:text-6xl text-forest mb-6" data-id="element-45">
          Auch dein Hund verdient einen ruhigen Bauch
        </h2>

        <p className="font-serif text-xl text-brown-dark/80 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-46">
          Teste das Magen-Darm-Topping jetzt risikofrei – mit
          Geld-zurück-Garantie. Keine Chemie. Nur Natur.
        </p>

        <div className="flex items-center justify-center gap-1.5 mb-10" data-id="element-47">
          <div className="flex" data-id="element-48">
            {[...Array(4)].map((_, i) => <Star key={i} className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-49" />)}
            <StarHalf className="w-5 h-5 fill-amber-500 text-amber-500" data-id="element-50" />
          </div>
          <span className="font-serif text-sm text-brown-dark/60 ml-1" data-id="element-51">
            4,4/5 · 876 Hundehalter haben es bewertet
          </span>
        </div>

        <div className="flex flex-col items-center mb-8" data-id="element-52">
          <a href={href} onClick={() => trackCTAClick('Hilf auch deinem Hund — natürlich & sanft', 'bottom_cta')} target="_blank" rel="noopener noreferrer" className="w-full md:w-auto inline-block bg-forest hover:bg-forest-light text-cream font-serif font-semibold text-lg md:text-xl py-4 px-8 md:px-12 rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 mb-3" data-id="element-53">
            Hilf auch deinem Hund — natürlich & sanft
          </a>
          <p className="font-serif text-[13px] italic text-brown-dark/60 text-center max-w-sm" data-id="element-54">
            Aufgrund hoher Nachfrage aktuell begrenzt verfügbar — viele
            Hunderunde-Kunden bestellen regelmäßig nach.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base font-serif text-brown-dark/70" data-id="element-55">
          <span className="flex items-center gap-2" data-id="element-56">
            <Check className="w-4 h-4 text-forest" data-id="element-57" /> Schneller Versand
          </span>
          <span className="flex items-center gap-2" data-id="element-58">
            <Check className="w-4 h-4 text-forest" data-id="element-59" /> Zufriedenheitsgarantie
          </span>
          <span className="flex items-center gap-2" data-id="element-60">
            <Check className="w-4 h-4 text-forest" data-id="element-61" /> 100% Natürliche
            Inhaltsstoffe
          </span>
        </div>
      </motion.div>
    </section>;
}